/**
 * <cta-finance> — ⓘ popover with the representative example in the slideshow CTA card
 * (snippets/m-slide-cta-card.liquid). Opens on click/tap, and on hover where the device has a
 * fine pointer. Closes on a second click, Escape (focus returns to the button), a click outside,
 * or the pointer leaving.
 */
if (!customElements.get('cta-finance')) {
  const HOVER_CLOSE_DELAY = 150;

  class CtaFinance extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button[aria-controls]');
      if (!this.button) return;
      this.panel = document.getElementById(this.button.getAttribute('aria-controls'));
      if (!this.panel) return;

      this.onDocumentClick = (event) => {
        if (!this.contains(event.target)) this.close();
      };
      this.onKeydown = (event) => {
        if (event.key === 'Escape' && this.isOpen()) {
          this.close();
          this.button.focus();
        }
      };

      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.isOpen()) {
          this.close();
        } else {
          this.open();
        }
      });

      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        this.addEventListener('mouseenter', () => {
          clearTimeout(this.closeTimer);
          this.open();
        });
        this.addEventListener('mouseleave', () => {
          this.closeTimer = setTimeout(() => this.close(), HOVER_CLOSE_DELAY);
        });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
    }

    isOpen() {
      return !this.panel.hidden;
    }

    open() {
      if (this.isOpen()) return;
      this.panel.hidden = false;
      this.button.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
    }

    close() {
      if (!this.isOpen()) return;
      this.panel.hidden = true;
      this.button.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
    }
  }

  customElements.define('cta-finance', CtaFinance);
}
